/**
 * The garage booking the landing page offers as an example: the job, a drop-off time and the
 * car's registration, for garages and dealer service desks (ADR-0024's first verticals).
 *
 * Kept deliberately plain, two screens and no branching, so it reads at a glance; the viewing
 * booking is the example that shows conditional questions and a branch. Drop-off times are fixed
 * here because an example has no diary behind it; with booking connected they come live.
 *
 * The JSON is compiled output, what the builder itself writes from these screens. The test holds
 * it to that: hydrate then compile must return it unchanged.
 */
export const GARAGE_BOOKING = {
  id: 'garage-booking',
  brief: 'MOT and service bookings for a garage: the job, a drop-off time and the car’s registration',
  reply: 'Here is a two-step booking: the job and a drop-off time, then the car and their details. The registration arrives with every booking, so nobody has to ask for it. With booking connected, the drop-off times come live from your workshop diary. Tell me your services and I will swap them in, or send it to your phone and book as a customer would.',
  name: 'MOT and service bookings',
  flowJson: {
  "version": "7.3",
  "screens": [
    {
      "id": "screen_a",
      "title": "Book your car in",
      "layout": {
        "type": "SingleColumnLayout",
        "children": [
          {
            "type": "RadioButtonsGroup",
            "name": "job",
            "label": "What does it need?",
            "required": true,
            "data-source": [
              { "id": "mot", "title": "MOT (45 min)" },
              { "id": "service", "title": "Full service (2 hrs)" },
              { "id": "both", "title": "MOT and service (3 hrs)" }
            ]
          },
          {
            "type": "RadioButtonsGroup",
            "name": "drop_off",
            "label": "Monday drop-off",
            "required": true,
            "data-source": [
              { "id": "t0800", "title": "08:00" },
              { "id": "t1030", "title": "10:30" },
              { "id": "t1330", "title": "13:30" }
            ]
          },
          {
            "type": "Footer",
            "label": "Continue",
            "on-click-action": {
              "name": "navigate",
              "next": { "type": "screen", "name": "screen_b" }
            }
          }
        ]
      }
    },
    {
      "id": "screen_b",
      "title": "Your car",
      "layout": {
        "type": "SingleColumnLayout",
        "children": [
          {
            "type": "TextInput",
            "name": "registration",
            "label": "Registration",
            "input-type": "text",
            "required": true
          },
          {
            "type": "TextInput",
            "name": "make_model",
            "label": "Make and model",
            "input-type": "text",
            "required": false
          },
          {
            "type": "TextInput",
            "name": "full_name",
            "label": "Your name",
            "input-type": "text",
            "required": true
          },
          {
            "type": "TextInput",
            "name": "phone",
            "label": "Mobile number",
            "input-type": "phone",
            "required": true
          },
          {
            "type": "Footer",
            "label": "Book it in",
            "on-click-action": {
              "name": "complete",
              "payload": {
                "job": "${screen.screen_a.form.job}",
                "drop_off": "${screen.screen_a.form.drop_off}",
                "registration": "${form.registration}",
                "make_model": "${form.make_model}",
                "full_name": "${form.full_name}",
                "phone": "${form.phone}"
              }
            }
          }
        ]
      },
      "terminal": true
    }
  ],
  "routing_model": {
    "screen_a": ["screen_b"]
  }
  },
};
